function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bau",
  d: "M22.36 2.34v-.014c-.145-.394-.545-.578-.884-.408l-6.31 3.156c-.17.084-.291.254-.364.437-.133.408.036.86.388 1.028.157.07.339.07.52-.014l6.3-3.156c.35-.17.508-.634.35-1.029zm-7.607 15.514l-3.028-3.001-2.035 1c-.412.198-.872-.014-1.041-.493-.17-.465.024-1 .424-1.197l1.32-.649-2.12-2.1-2.204 1.804-2.266 1.832c-.472.395-.872.86-1.199 1.339a6.854 6.854 0 00-.787 1.69 4.92 4.92 0 00-.242 1.325c0 .226.024.508.097.62.072.141.302.296.642.465.4.212.92.38 1.502.508.726.14 1.586.211 2.458.127.751-.07 1.515-.24 2.217-.55a875.382 875.382 0 006.262-2.72zm2.048-.38c.448.437.339 1.31-.23 1.55-2.508 1.1-5.015 2.184-7.523 3.27-.872.38-1.78.59-2.652.661a9.36 9.36 0 01-2.847-.155c-.715-.14-1.357-.352-1.865-.62-.606-.31-1.066-.69-1.32-1.113C.17 20.673 0 20.236 0 19.362c.012-.578.121-1.24.327-1.888a8.56 8.56 0 011.03-2.198 7.56 7.56 0 011.55-1.72c1.647-1.352 3.307-2.705 4.954-4.058a.7.7 0 01.97.057l2.24 2.226V7.568c0-.366.194-.69.485-.845l1.623-.804c-.012-.38.048-.746.157-1.085.218-.634.642-1.155 1.212-1.451L21.004.156c1.126-.479 2.35.183 2.81 1.452.497 1.324-.036 2.888-1.175 3.452l-6.31 3.156a1.944 1.944 0 01-1.72.028 2.245 2.245 0 01-.812-.634l-1.14.564v5.171l4.144 4.129z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bau-mask",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bau"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#1A1A1A",
  fillRule: "nonzero",
  xlinkHref: "#bau"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#910055",
  mask: "url(#bau-mask)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24-2.09H0v28h24z"
})))));